import React, { Component } from 'react';

export default class IntegerInput extends Component {
    constructor() {
        super();

        this.state = { value: null };
        this.changeValue = this.changeValue.bind(this);
        this.catchKeypress = this.catchKeypress.bind(this);
        this.timeout = null;
        this.lastCorrectValue = null;

        this.defaultMin = 0;
        this.defaultMax = 100;
        this.defaultTimeoutTime = 750;
    }

    getValue() {
        const parsedValue = parseInt(this.state.value);
        if (isNaN(parsedValue)) {
            return '';
        } else {
            return parsedValue.toString();
        }
    }

    render() {
        if (typeof this.props.fieldName === 'string' && this.props.fieldName) {
            const getLabel = () => {
                if (typeof this.props.label === 'string' && this.props.label.length > 0) {
                    return (
                        <label htmlFor={this.props.fieldName} className="form__label">
                            {this.props.label}
                            {typeof this.props.required === 'boolean' && this.props.required ? (
                                <sup> *</sup>
                            ) : (
                                <></>
                            )}
                        </label>
                    );
                } else return <></>;
            };

            return (
                <>
                    {getLabel()}
                    <input
                        type={
                            typeof this.props.textMode === 'boolean' && this.props.textMode
                                ? 'text'
                                : 'number'
                        }
                        name={this.props.fieldName}
                        className="form__input"
                        title={
                            typeof this.props.title === 'string' && this.props.title.length > 0
                                ? this.props.title
                                : null
                        }
                        onKeyUp={this.changeValue}
                        onChange={this.changeValue}
                        onKeyPress={this.catchKeypress}
                        value={this.getValue()}
                        required={typeof this.props.required === 'boolean' && this.props.required}
                    />
                </>
            );
        } else {
            console.error('fieldName is obligatory!');
            return <></>;
        }
    }

    catchKeypress(e) {
        // avoid entering ANYTHING other than numbers ("e", ".", ",", etc)
        // e.g. typing "5." resulted with value: "", WTF
        if (e.charCode < 48 || e.charCode > 57) {
            e.preventDefault();
        }
    }

    changeValue(e) {
        const emitChange = (val) => {
            if (typeof this.props.onChange === 'function') {
                this.props.onChange(val);
            }
        };

        if (
            typeof this.props.timeoutEnabled === 'boolean' &&
            this.props.timeoutEnabled &&
            this.timeout !== null
        ) {
            clearTimeout(this.timeout);
        }

        let val = null;
        if (e.target.value === '') {
            if (typeof this.props.allowEmptyValue === 'boolean' && this.props.allowEmptyValue) {
                val = '';
            } else {
                val = 0;
            }
        } else {
            val = parseInt(e.target.value, 10);
        }

        let min = this.defaultMin;
        let max = this.defaultMax;

        if (typeof this.props.min === 'number') {
            min = parseInt(this.props.min);
        }
        if (typeof this.props.max === 'number') {
            max = parseInt(this.props.max);
        }

        if ((!isNaN(val) && val >= min && val <= max) || val === '') {
            this.lastCorrectValue = val;

            this.setState({ value: val });

            if (this.timeoutEnabled) {
                this.timeout = setTimeout(() => {
                    emitChange(val);
                }, this.defaultTimeoutTime);
            } else {
                emitChange(val);
            }
        } else {
            // revert last value when entered some bullshit
            // input.value = this.lastCorrectValue;
            this.setState({ value: this.lastCorrectValue });
        }
    }
}
